import React, { useRef, useState } from 'react';
import cls from './Sidebar.module.scss';
import useNavigations from 'src/hooks/routes/useNavigations';
import Tooltip from '../../UI/Tooltip/Tooltip';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { Fade, Popper } from '@mui/material';
import { ReactComponent as LogoNew } from 'src/assets/img/icons/logo-new.svg';

const Sidebar = () => {
  const { navigations } = useNavigations();
  const { pathname } = useLocation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const navRef = useRef<HTMLElement | null>(null);
  const popperRef = useRef<HTMLDivElement | null>(null);

  const handleAnchorSet = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleAnchorClear = () => setAnchorEl(null);

  const handleMouseLeave = (event: React.MouseEvent<HTMLElement>) => {
    const relatedTarget = event.relatedTarget as Node | null;

    if (
      relatedTarget instanceof Node &&
      !navRef?.current?.contains(relatedTarget as Node) &&
      !popperRef?.current?.contains(relatedTarget as Node)
    ) {
      setAnchorEl(null);
    }
  };

  const canBeOpen = Boolean(anchorEl);
  const id = canBeOpen ? 'transition-popper' : undefined;

  return (
    <nav
      className={cls.sidebar_container}
      ref={navRef}
      onMouseLeave={handleMouseLeave}
    >
      <LogoNew className={cls.logo} />
      {navigations.map((item) => {
        const isActiveTab = item.routes?.some((i) => i.path === pathname);
        const isCurrentRoute = pathname === item.path;

        if (item.disabled) return null;

        return item.path ? (
          <Tooltip placement="right" title={item.title} key={item.title}>
            <NavLink
              aria-current="page"
              onMouseEnter={handleAnchorClear}
              className={isCurrentRoute ? cls.active : ''}
              to={item.disabled ? '' : item.path}
              data-qa-selector={item.id || item.path}
            >
              {item.icon}
            </NavLink>
          </Tooltip>
        ) : (
          <button
            aria-describedby={id}
            onMouseEnter={handleAnchorSet}
            id={item.title}
            className={isActiveTab ? cls.active : ''}
            type="button"
            data-qa-selector={`nav-button-${item.id}`}
          >
            {item.icon}
          </button>
        );
      })}{' '}
      <Popper
        sx={{ marginLeft: '8px!important' }}
        ref={popperRef}
        disablePortal
        id={id}
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        transition
        placement="right-start"
        onMouseLeave={handleMouseLeave}
      >
        {({ TransitionProps }) => {
          const tab = navigations.find(({ title }) => title === anchorEl?.id);

          return (
            <Fade {...TransitionProps} timeout={350}>
              <div className={cls.popper_container}>
                <p>{tab?.title}</p>
                <div className={'column gap-5 mt-10'}>
                  {tab?.routes?.map((item) => {
                    return item.disabled ? null : (
                      <Link
                        className={'flex-align-center gap-10'}
                        to={item.path}
                        key={item.path}
                        data-qa-selector={item.path}
                      >
                        {item.icon} {item.title}
                      </Link>
                    );
                  })}
                </div>
              </div>
            </Fade>
          );
        }}
      </Popper>
    </nav>
  );
};

export default Sidebar;
